import { useNavigate } from '@tanstack/react-router';
import useSidebarStack from '@/common/sidebar/useSidebarStack.ts';
import { useCallback } from 'react';

const ACTIONS_WITHOUT_HREF = new Set(['viewAssets', 'viewLifts']);

export function canRunNotificationActionWithoutHref(actionId: string): boolean {
  return ACTIONS_WITHOUT_HREF.has(actionId);
}

export default function useNotificationActionHandler() {
  const navigate = useNavigate();
  const sidebarStack = useSidebarStack();

  return useCallback(
    (actionId: string, href: string) => {
      if (actionId === 'viewWorkOrder') {
        sidebarStack.pushItem('workOrderDetails', {
          workOrderId: href,
          workOrderExternalId: '',
        });
        return true;
      } else if (actionId === 'viewSupportCase') {
        sidebarStack.pushItem('supportCaseDetails', {
          supportCaseId: href,
          supportCaseExternalId: '',
        });
        return true;
      } else if (actionId === 'viewAssets') {
        navigate({ to: '/assets' });
        return true;
      } else if (actionId === 'viewLifts') {
        navigate({ to: '/big-rentz-lifts' });
        return true;
      } else if (actionId === 'viewSalesOrder') {
        sidebarStack.pushItem('salesOrderDetail', {
          salesOrderId: href,
          salesOrderExternalId: '',
          defaultTab: 'notes',
        });
        return true;
      }
      return false;
    },
    [navigate, sidebarStack],
  );
}
